import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {SubTasksDialogService} from "../../services/sub-tasks-dialogs-service.service";
import {SubTasksService} from "../../services/sub-tasks-service.service";

export class subTasksTemplatesViewCtrl implements IController {

  templates: any;
  selectedType: any;
  actions: any;

  /* @ngInject */
  constructor(private subTasksService: SubTasksService, private subTasksDialogService: SubTasksDialogService) {
  }

  // ******************************
  //        Public methods
  // ******************************

  onTabSelect(type) {
    if (this.selectedType !== type) {
      this.selectedType = type;
      this._getTemplatesByType(type)
    }
  }

  onCreateSubTaskTemplate($event) {
    this.subTasksDialogService.createTemplate(this.actions, $event)
      .then((subTaskTemplateToCreate) => {
        this._createTemplate(subTaskTemplateToCreate)
      })
  }

  onEditSubTaskTemplate(subTaskTemplate, $event) {
    this.subTasksDialogService.editTemplate(this.actions, subTaskTemplate, $event)
      .then((subTaskTemplateToUpdate) => {
        this._updateTemplate(subTaskTemplateToUpdate)
      })
  }

  onDeleteSubTaskTemplate(subTaskTemplate) {
    this._deleteTemplate(subTaskTemplate.templateId)
  }

  // ******************************
  //        Private methods
  // ******************************

  _createTemplate(subTaskTemplate) {
    if (!subTaskTemplate.types) {
      subTaskTemplate.types = [this.selectedType];
    }
    this.subTasksService.createTemplate(subTaskTemplate)
      .then((createdTemplate) => {
        this.templates.push(createdTemplate);
      })
  }

  _updateTemplate(subTaskTemplate) {
    this.subTasksService.updateTemplate(subTaskTemplate.templateId, subTaskTemplate)
      .then((updatedTemplate: any) => {
        const index = _.findIndex(this.templates, (t: any) => {
          return t.templateId === updatedTemplate.templateId;
        });
        if (index > -1) {
          const templatesCopy = angular.copy(this.templates);
          templatesCopy[index] = updatedTemplate;
          this.templates = templatesCopy;
        }
      })
  }

  _deleteTemplate(subTaskTemplateId) {
    this.subTasksService.deleteTemplate(subTaskTemplateId)
      .then((deletedTemplate: any) => {
        this.templates = _.filter(this.templates, (t) => {
          return t.templateId !== deletedTemplate.templateId;
        });
      })
  }

  _getTemplatesByType(type) {
    this.templates = [];
    this.subTasksService.getTemplates([type])
      .then((templates) => {
        this.templates = templates;
      })
  }

}

angular
  .module('bringoz.admin.sub-tasks')
  .component('subTasksTemplatesView', {
    bindings: {
      templates: '<',
      selectedType: '<',
      actions: '<'
    },
    template: require('./sub-tasks-templates-view.html').default,
    controller: subTasksTemplatesViewCtrl
  });
